import React from 'react';
import PropTypes from 'prop-types';

import OrganizationChartV2 from '../../components/OrganizationChartV2';
import AnimatedLogo from '../../components/AnimatedLogo/AnimatedLogo';
import ListZeroState from '../../components/ListZeroState';
import { t } from '../../i18n';
import s from './ConnectionsCompanyPage.module.scss';

// A chart of just the company itself has nothing to show or export.
export const hasNetworkData = (orgChart = []) => orgChart.length > 1;

export const NetworkTab = ({
    orgChart = [],
    activeId = null,
    isLoading = false,
    hasError = false,
    exportRef = null,
    fileName = 'organization-chart',
    lastUpdated = '',
}) => {
    if (isLoading) {
        return (
            <div className={s.ChartLoading}>
                <AnimatedLogo width={29} height={34} stroke="#616161" />
                <div className={s.ChartLoadingText}>
                    {t('connectionsCompanyPage.chartLoading')}
                </div>
            </div>
        );
    }

    if (hasError) {
        return (
            <div className={s.ZeroStateWrapper}>
                <ListZeroState
                    title={t('connectionsCompanyPage.chartErrorLabel')}
                    text={t('connectionsCompanyPage.chartErrorText')}
                />
            </div>
        );
    }

    if (!hasNetworkData(orgChart)) {
        return (
            <div className={s.ZeroStateWrapper}>
                <ListZeroState
                    title={t(
                        'connectionsPage.holdings.noOrganizationDataLabel'
                    )}
                    text={t('connectionsPage.holdings.noOrganizationDataText')}
                />
            </div>
        );
    }

    return (
        <>
            <div className={s.Network}>
                <OrganizationChartV2
                    nodes={orgChart}
                    activeId={activeId}
                    exportRef={exportRef}
                    fileName={fileName}
                />
            </div>
            {lastUpdated && (
                <p className={s.LastUpdated}>
                    {t('connectionsCompanyPage.networkLastUpdated', {
                        date: lastUpdated,
                    })}
                </p>
            )}
        </>
    );
};

NetworkTab.propTypes = {
    orgChart: PropTypes.array,
    activeId: PropTypes.string,
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool,
    exportRef: PropTypes.object,
    fileName: PropTypes.string,
    lastUpdated: PropTypes.string,
};
